export default __webpack_public_path__ + "static/media/h.a4a93aa1.png";